module.exports = __webpack_public_path__ + "img/14.cc221b27.jpg";